/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';

@Injectable()
export class LogService {
    /**
     * Store is this is enabled.
     * @private
     */
    private enabled: boolean = false;

    /**
     * Store log level.
     * @private
     */
    private level = {
        DEBUG: 1,
        WARN: 2,
        ERROR: 3,
        INFO: 4,
        css: {
            1: { background: 'none', color: '#51A3A3' },
            2: { background: 'none', color: '#cb9a30' },
            3: { background: 'none', color: '#FD8267' },
            4: { background: 'none', color: '#59697D' },
        }
    };

    /**
     * Set if production mode or not.
     * @private
     */
    private production: boolean = false;

    /**
     * Toggle logging
     */
    public toggle(): void {
        this.enabled = !this.enabled;
    }

    /**
     * Set environment setting
     * @param {number} production
     */
    public setEnvironment(production: boolean): void {
        this.info('LogService', 'LB log environment set.');
        this.production = production;
    }

    /**
     * Debug logging
     * @param {string} title
     * @param {string} message
     * @param {Object} data
     */
    public debug(title: string, message: string, data: any = null): void {
        if (this.enabled && !this.production) {
            // eslint-disable-next-line no-console
            console.log('%c[DEBUG][' + new Date() + '] ' +
                title + ' ' + message,
                'background:' + this.level.css[this.level.DEBUG].background + ';' +
                'color:' + this.level.css[this.level.DEBUG].color + ';', '\n', data || '');
        }
    }

    /**
     * Warning logging
     * @param {string} title
     * @param {string} message
     * @param {Object} data
     */
    public warn(title: string, message: string, data: any = null): void {
        if (this.enabled && !this.production) {
            // eslint-disable-next-line no-console
            console.log('%c[WARNING][' + new Date() + '] ' +
                title + ' ' + message,
                'background:' + this.level.css[this.level.WARN].background + ';' +
                'color:' + this.level.css[this.level.WARN].color + ';', '\n', data || '');
        }
    }

    /**
     * Error logging
     * @param {string} title
     * @param {string} message
     * @param {Object} data
     */
    public error(title: string, message: string, data: any = null): void {
        // eslint-disable-next-line no-console
        console.log('%c[ERROR][' + new Date() + '] ' +
            title + ' ' + message,
            'background:' + this.level.css[this.level.ERROR].background + ';' +
            'color:' + this.level.css[this.level.ERROR].color + ';', '\n', data || '');
    }

    /**
     * Information logging
     * @param {string} title
     * @param {string} message
     * @param {Object} data
     */
    public info(title: string, message: string, data: any = null): void {
        if (this.enabled && !this.production) {
            // eslint-disable-next-line no-console
            console.log('%c[INFO][' + new Date() + '] ' +
                title + ' ' + message,
                'background:' + this.level.css[this.level.INFO].background + ';' +
                'color:' + this.level.css[this.level.INFO].color + ';', '\n', data || '');
        }
    }
}
